import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Badge } from "@/components/ui/badge";
import { Building2 } from "lucide-react";
import Messages from "@/components/Messages";

export default function WholesaleDashboard() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  useEffect(() => { api.get("/orders").then((r) => setOrders(r.data)); }, []);

  const stat = (label, value, testid) => (
    <div data-testid={testid} className="bg-white border border-stone-200 p-6 rounded-md">
      <div className="text-xs uppercase tracking-[0.2em] text-stone-500 font-semibold">{label}</div>
      <div className="mt-3 font-serif text-3xl text-stone-900">{value}</div>
    </div>
  );

  return (
    <div className="space-y-8">
      <div className="bg-stone-900 rounded-md p-8 flex items-center gap-5">
        <Building2 className="text-amber-300" size={32} />
        <div>
          <div className="font-serif text-2xl text-stone-50">Wholesale Account Active</div>
          <div className="text-sm text-stone-300 font-sans mt-1">Your account is being tracked by Azure Gypsy admins. Larger orders unlock dedicated routes.</div>
        </div>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
        {stat("Bulk Orders", orders.length, "stat-bulk-orders")}
        {stat("Active", orders.filter((o) => o.status !== "delivered").length, "stat-bulk-active")}
        {stat("Delivered", orders.filter((o) => o.status === "delivered").length, "stat-bulk-delivered")}
        {stat("State", user.state || "—", "stat-bulk-state")}
      </div>

      <Tabs defaultValue="orders">
        <TabsList className="bg-stone-100">
          <TabsTrigger data-testid="tab-bulk-orders" value="orders">Bulk Orders</TabsTrigger>
          <TabsTrigger data-testid="tab-messages" value="messages">Messages</TabsTrigger>
        </TabsList>
        <TabsContent value="orders" className="mt-6 space-y-3">
          {orders.length === 0 ? (
            <div className="bg-white border border-stone-200 p-10 text-center rounded-md font-sans text-stone-500">No wholesale orders yet — visit the marketplace and filter by Wholesale.</div>
          ) : orders.map((o) => (
            <div key={o.order_id} className="bg-white border border-stone-200 rounded-md p-5 flex justify-between items-center">
              <div>
                <div className="font-serif text-lg text-stone-900">{o.product_title}</div>
                <div className="text-xs text-stone-500 mt-1 font-sans">Qty {o.quantity} · From {o.farmer_name} (hobby farmer)</div>
              </div>
              <Badge className="bg-stone-800 text-stone-50">{o.status}</Badge>
            </div>
          ))}
        </TabsContent>

        <TabsContent value="messages" className="mt-6">
          <Messages />
        </TabsContent>
      </Tabs>
    </div>
  );
}
